/* eslint-disable formatjs/no-literal-string-in-jsx */
import { useTheme } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

const SignupToLogin = () => {
  const theme = useTheme();
  return (
    <div>
      <p style={{ textAlign: "center", marginTop: "20px" }}>
        <FormattedMessage id="SignupToLogin.hasAccount" />{" "}
        <Link
          to="/login"
          style={{
            color: theme.palette.primary.main,
          }}
        >
          <FormattedMessage id="SignupToLogin.logIn" />
        </Link>
      </p>
    </div>
  );
};

export { SignupToLogin };
